// Provedor de tiles do mapa, em um lugar só.
//
// Isto já quebrou duas vezes por motivo externo: a OpenStreetMap aposentou os
// subdomínios a./b./c. e depois bloqueou a aplicação por uso comercial (os
// servidores deles são mantidos por voluntários), e o Carto passou a exigir
// API key, carimbando "API KEY REQUIRED" dentro da própria imagem. Nas duas
// vezes a URL estava duplicada em 6 telas, e trocar virou caça ao arquivo.
//
// Padrão: Esri World Street Map — CDN comercial, sem chave, rótulos em
// português. Note a ordem {z}/{y}/{x}, diferente do padrão {z}/{x}/{y} da OSM.
//
// Para migrar pra um provedor com contrato (Carto, MapTiler, Stadia), defina
// REACT_APP_TILE_URL e REACT_APP_TILE_ATTRIBUTION no build — sem tocar em
// nenhuma tela. A chave de tiles é pública por natureza (roda no navegador);
// restrinja por domínio no painel do provedor.

const ESRI = 'https://server.arcgisonline.com/ArcGIS/rest/services';

export const TILE_URL =
  process.env.REACT_APP_TILE_URL || `${ESRI}/World_Street_Map/MapServer/tile/{z}/{y}/{x}`;

export const TILE_ATTRIBUTION =
  process.env.REACT_APP_TILE_ATTRIBUTION ||
  'Tiles &copy; <a href="https://www.esri.com">Esri</a>';

// Modo Motorista usa base escura — decisão de design pra dirigir à noite. O
// "Reference" é a camada transparente só com os rótulos, sobreposta à base.
export const TILE_URL_DARK =
  process.env.REACT_APP_TILE_URL_DARK || `${ESRI}/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}`;

export const TILE_URL_DARK_LABELS =
  process.env.REACT_APP_TILE_URL_DARK_LABELS ||
  `${ESRI}/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}`;

export const TILE_MAX_ZOOM = 19;
